import { Button, Flex } from "antd";
import ProposalGoalPreviewGrowth from "../../../../../../proposal/component/ProposalGoalPreviewGrowth";
import ProposalGoalPreviewIncome from "../../../../../../proposal/component/ProposalGoalPreviewIncome";

import { openProposal } from "../../../../../../../../../utils/request/manager";
import { getValidProductId } from "../../../../../../proposal/helper";

const TabProposals = ({
  clientData,
  managerEmail,
  organization,
  productsList,
}) => {
  const productMap = clientData?.valueMap?.productMap;

  const handleDownloadProposal = goalId => {
    openProposal({
      advisorEmail: clientData.advisorEmail,
      clientEmail: clientData.email,
      managerEmail,
      modeDownloadPdf: true,
      goalId,
      windowName: "adminView",
    });
  };

  const handleViewProposal = goalId => {
    openProposal({
      advisorEmail: clientData.advisorEmail,
      clientEmail: clientData.email,
      managerEmail,
      goalId,
    });
  };

  const ProposalGoalFooter = ({ goalId }) => (
    <Flex justify="end">
      <Button onClick={() => handleViewProposal(goalId)} shape="round">
        View Proposal
      </Button>
    </Flex>
  );

  return (
    <Flex gap={32} style={{ padding: "16px 32px", overflow: "auto" }}>
      {productMap &&
        Object.keys(productMap).map(goalId => {
          const proposalData =
            productMap[goalId][productMap[goalId].length - 1];

          const validatedProposalData = {
            ...proposalData,
            productId: getValidProductId({
              organization,
              productsList,
              proposalProductId: proposalData.productId,
              proposalRiskTolerance: proposalData.riskTolerance?.toLowerCase(),
            }),
          };

          const productData = productsList?.find(
            it => it._id === validatedProposalData.productId
          );

          return proposalData?.investmentObjective === "growth" ? (
            <ProposalGoalPreviewGrowth
              Footer={() => <ProposalGoalFooter goalId={goalId} />}
              handleDownloadProposal={() => handleDownloadProposal(goalId)}
              key={goalId}
              proposalData={validatedProposalData}
              productData={productData}
            />
          ) : (
            <ProposalGoalPreviewIncome
              Footer={() => <ProposalGoalFooter goalId={goalId} />}
              handleDownloadProposal={() => handleDownloadProposal(goalId)}
              key={goalId}
              proposalData={validatedProposalData}
              productData={productData}
            />
          );
        })}
    </Flex>
  );
};

export default TabProposals;
